export const NEW_YORK = {
  maxLat: 40.9176,
  maxLng: -73.7004,
  minLat: 40.4774,
  minLng: -74.2589,
}

export const BOSTON = {
  maxLat: 42.4660319365,
  maxLng: -70.8414633815,
  minLat: 42.181736568,
  minLng: -71.2781699245,
}

export const NO_FEE_CITIES = [NEW_YORK, BOSTON]
